import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/hope-page/hope-page.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};